// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { GSP_DATA_COLOUR_SCHEMES } from "src/lib/data.js";
import { Tooltip } from "src/modules/tooltip/jsx/component.jsx";
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";
import { makeDate } from "src/lib/utils.js";

// Stateful components
export class TrimesterOverview extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
           "programs": [],
           "course_profiles": [],
           "current_trimester": null,
           "trimester_count": 1,
           "current_trimester_index": 0
        };

        // Binds
        this.nextTrimester = this.nextTrimester.bind(this);
        this.previousTrimester = this.previousTrimester.bind(this);
        this.RenderCourseDisplay = this.RenderCourseDisplay.bind(this);
        this.RenderPaginationButton = this.RenderPaginationButton.bind(this);
        this.RenderAssessments = this.RenderAssessments.bind(this);
        this.toggleAssessments = this.toggleAssessments.bind(this);
        this.toggleCoordinatorPopup = this.toggleCoordinatorPopup.bind(this);
        this.findAncestor = this.findAncestor.bind(this);
        this.clearAllOpenedElements = this.clearAllOpenedElements.bind(this);
        this.toggleIndividualAssessment = this.toggleIndividualAssessment.bind(this);
    }

    componentDidMount(){
        var this_component = this;
        
        this_component.getProgramData();
    }

    componentDidUpdate(prev_props, prev_state) {
        var this_component = this;

        // New Program
        var programs_index = this_component['props']['index'];
        if(programs_index !== prev_props['index']) {
            this_component.getProgramData();
        }
    }

    //
    // Functions
    //

    getProgramData() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var courses_storage = squiz.fn.getStorage('getmycourses', 'session', 'json');

        var programs = courses_storage['data']['programs'];
        var course_profiles = courses_storage['data']['courseProfiles'];
        var programs_index = this_component['props']['index'];
        var current_trimester = null;
        var total_trimesters_in_data = 1;

        var mapped_course_codes = {};

        if(typeof programs != 'undefined' && programs.length > 0){
            if(typeof programs[programs_index]['teachingPeriods'] != 'undefined' ){

                // compile course codes for this data
                for(var index = 0; index < programs.length; index++){
                    for(var teachingPeriods_index = 0; teachingPeriods_index < programs[index]['teachingPeriods'].length; teachingPeriods_index++){
                        var this_course = programs[index]['teachingPeriods'][teachingPeriods_index]['courses'];
                        mapped_course_codes = squiz['fn']['colour']['compileCourseCodes'](this_course, mapped_course_codes);
                    }
                }

                // get colour data from storage
                var colour_storage = squiz.fn.getStorage('getallstorage', 'session', 'json');
                colour_storage = colour_storage['data']['coursecolours'];

                var codes_match = false;
                // check if colour_storage codes match the mapped_course_codes
                var mapped_course_codes_keys = Object.keys(mapped_course_codes).sort();
                // undefined colour_storage will throw an error, so make sure it's available before checking
                if(typeof colour_storage != 'undefined'){
                    var colour_storage_keys = Object.keys(colour_storage).sort();
                    codes_match = JSON.stringify(mapped_course_codes_keys) === JSON.stringify(colour_storage_keys);
                }

                if(!colour_storage || !codes_match){
                    // if no local colour schemes, assume none have been set up.
                    // set random colours to the data based on course codes
                    mapped_course_codes = squiz['fn']['colour']['randomlyAssignColoursToCourseCodes'](mapped_course_codes, GSP_DATA_COLOUR_SCHEMES);
                    //mapped_course_codes = this_component.randomlyAssignColoursToCourseCodes(mapped_course_codes);

                    // write 
                    // write new colour scheme back to gatekeeper
                    helpers.setColoursToStorage(mapped_course_codes);
                } else {
                    mapped_course_codes = colour_storage;
                }
                // aplpy colour schemes to the data

                
                for(var index = 0; index < programs.length; index++){
                    for(var teachingPeriods_index = 0; teachingPeriods_index < programs[index]['teachingPeriods'].length; teachingPeriods_index++){
                        var this_course = programs[index]['teachingPeriods'][teachingPeriods_index]['courses'];
                        this_course = squiz['fn']['colour']['assignColoursToData'](this_course, mapped_course_codes);
                    }
                }


                // assume the first array item is the current trimester
                total_trimesters_in_data = programs[programs_index]['teachingPeriods'].length;
                current_trimester = programs[programs_index]['teachingPeriods'][0];

                this_component.setState({
                    "programs": programs,
                    "course_profiles": course_profiles,
                    "current_trimester": current_trimester,
                    "trimester_count": total_trimesters_in_data
                });

            }
        }
    }

    nextTrimester(event){
        event.preventDefault();
        var this_component = this;
        var programs = this_component['state']['programs'];
        var programs_index = this_component['props']['index'];
        var trimester_index = this_component['state']['current_trimester_index'] + 1;
        var current_trimester = programs[programs_index]['teachingPeriods'][trimester_index];
        this_component.clearAllOpenedElements();

        this_component.setState({
            "current_trimester": current_trimester,
            "current_trimester_index": trimester_index
        });
    }
    previousTrimester(event){
        event.preventDefault();
        var this_component = this;
        var programs = this_component['state']['programs'];
        var programs_index = this_component['props']['index'];
        var trimester_index = this_component['state']['current_trimester_index'] - 1;
        var current_trimester = programs[programs_index]['teachingPeriods'][trimester_index];
        this_component.clearAllOpenedElements();

        this_component.setState({
            "current_trimester": current_trimester,
            "current_trimester_index": trimester_index
        });
    }

    clearAllOpenedElements(){
        var active_content = document.querySelector('.trimester-overview__wrapper');
        var opened_elements = active_content.querySelectorAll('[class*="--open"]');

        for(var index = 0; index < opened_elements.length; index++){
            //var classes = opened_elements[index].className.split(" ").filter(classname => !classname.indexOf('--open'));
            var classes = opened_elements[index].className.split(" ").filter(function(classname){
                return classname.indexOf('--open') === -1;
            });
            opened_elements[index].className = classes.join(" ").trim();
        }
    }
    toggleAssessments(event){
        event.preventDefault();
        var parent = event.target.parentElement;
        event.target.classList.toggle('course-tile__assessment__title--open');
        parent.nextSibling.classList.toggle('course-tile__assessment__dropdown--open');
    }

    toggleIndividualAssessment(event){
        event.preventDefault();
        var parent = event.target.parentElement;
        parent.classList.toggle('course-tile__assessment__item--open');
    }

    toggleCoordinatorPopup(event){
        var this_component = this;
        event.preventDefault();
        var parent = this_component.findAncestor(event.target, '.course-tile__coordinator');
        parent.classList.toggle('course-tile__coordinator--open');
        
    }
    
    findAncestor(el, cls) {
        cls = cls.replace('\.', '');
        while ((el = el.parentNode) && el.className.indexOf(cls) < 0);
        return el;
    }

    //
    // Render
    //
    RenderCourseDisplay(props){
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        var courses = props['currentTrimester']['courses'];

        return (
            <>
            
                {courses.map((item, index) => (
                    <div className={'course-tile course-tile--' + item['colour']['name']} key={index}>
                        <div className="course-tile__code">
                            {item['code']}
                        </div>
                        {item['blackboardUrl'] ? <>
                            <a href={item['blackboardUrl']} className="course-tile__title">
                                {item['name']}
                            </a>
                        </> : <>
                            <span className="course-tile__title">
                                {item['name']}
                            </span>
                        </>}
                        

                        <div className="course-tile__coordinator">
                            {item['convenor'] ? (
                                <Tooltip content={{
                                    'title': item['convenor'],
                                    'info':  item['code'] + '-' + item['name'],
                                    'email': item['convenorEmail'],
                                    'button': {
                                        'class': 'coordinator-modal__name__button',
                                        'text': item['convenor']
                                    }
                                }} />
                            ) : configuration['system_messages']['nodata']['programConvenor']}
                            
                        </div>

                        <div className="course-tile__assessment__wrapper">
                            <button className="course-tile__assessment__title" onClick={this_component['toggleAssessments']}>
                                Assessments
                            </button>
                        </div>
                        <div className="course-tile__assessment__dropdown">
                            <this_component.RenderAssessments courseProfileId={item['courseProfileId']} />
                        </div>
                        
                        <div className="course-tile__course-profile__link__wrapper">
                            {item['courseProfileUrl'] ? <>
                                <a href={item['courseProfileUrl']} className="course-tile__course-profile__link">View course profile</a>
                            </> : <>
                                <span className="course-tile__course-profile__link">
                                    Course profile not available.
                                </span>
                            </>}
                        </div>

                    </div>
                ))}
            
            </>
        );

    }

    printDueDate(item) {
        var dueDateText = '';
        var date_format = 'Do MMMM YYYY';
        if(item['title'].indexOf('Exam') !== -1){
            dueDateText = 'Examination Period'
        }else if(item['dueDate'] !== ""){
            dueDateText = makeDate(item['dueDate'], date_format);
        }else if(item['otherDueInfo'] !== ''){
            dueDateText = item['otherDueInfo'];
        }
        return dueDateText;
    }


    RenderAssessments(props){
        var this_component = this;
        var portal_context = this_component['context'];
        var course_profiles = this_component['state']['course_profiles'];
        var course_profile_id = props['courseProfileId'];
        var assessments = null;
        // in courseProfiles, find the object that matches courseProfileId
        // iterate through each assesment objects and output them

        // only run if course_profiles has data
        if(course_profiles.length > 0){
            for(var index = 0; index < course_profiles.length; index++){
                if(course_profiles[index] != null){
                    if(typeof course_profiles[index]['courseProfileId'] != 'undefined'){
                        if(course_profiles[index]['courseProfileId'] == course_profile_id){
                            // course found
                            assessments = course_profiles[index]['assessmentItems'];
                            break;
                        }
                    }
                }
            }
            if(assessments){
                var date_format = 'Do MMMM YYYY';

                // if assessments has content
                return (
                    assessments.filter(function(item) {
                        if (item === null) return false; // skip
                        return true;
                    }).map((item, index) => (
                        
                        <div className="course-tile__assessment__item" key={index}>
                            <button className="course-tile__assessment__item__toggler" onClick={this_component['toggleIndividualAssessment']}>
                                {item['assessmentType']}
                            </button>
                            <div className="course-tile__assessment__item__col">
                                <div className="course-tile__assessment__item__title">
                                    Type
                                </div>
                                <div className="course-tile__assessment__item__info">
                                    {item['assessmentType']}
                                </div>
                            </div>
                            <div className="course-tile__assessment__item__col">
                                <div className="course-tile__assessment__item__title">
                                    Title
                                </div>
                                <div className="course-tile__assessment__item__info">
                                    {item['title']}
                                </div>
                            </div>
                            <div className="course-tile__assessment__item__col">
                                <div className="course-tile__assessment__item__title">
                                    Due
                                </div>
                                <div className="course-tile__assessment__item__info">
                                    <div>{this.printDueDate(item)}</div>
                                </div>
                            </div>
                            <div className="course-tile__assessment__item__col">
                                <div className="course-tile__assessment__item__title">
                                    Weighting
                                </div>
                                <div className="course-tile__assessment__item__info">
                                    {item['weighting']}
                                </div>
                            </div>
                        </div>
                    ))
                );
            }
        }

        // fallback return for when no data is present
        var configuration = portal_context['configuration'];
        var error = configuration['system_messages']['nodata']['programAssessment'];

        return (
            <p>{error}</p>
        );
    }

    RenderPaginationButton(props) {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];

        var pagination_label = 'term';
        if (configuration['my_program'] && configuration['my_program']['pagination_label']) {
            pagination_label = configuration['my_program']['pagination_label'];
        }

        var pager_direction = props['direction'];
        var current_trimester_index = this_component['state']['current_trimester_index'];
        var trimester_count = this_component['state']['trimester_count'];
        var clickEvent = function(event){event.preventDefault()};
        if (pager_direction == 'next') {
            var classes = 'trimester-overview__arrow--right';
            
            if((current_trimester_index + 1) == trimester_count) {
                classes += ' trimester-overview__arrow--disabled';
            } else {
                clickEvent = this_component['nextTrimester'];
            }
            return (
                <>
                <button className={classes} onClick={clickEvent}>
                    <span className="trimester-overview__arrow__text">
                        Next {pagination_label}
                    </span>
                </button>
                </>
            );
        } else {
            var classes = 'trimester-overview__arrow--left';
            
            if(current_trimester_index == 0) {
                classes += ' trimester-overview__arrow--disabled';
            } else {
                clickEvent = this_component['previousTrimester'];
            }
            return (
                <>
                <button className={classes} onClick={clickEvent}>
                    <span className="trimester-overview__arrow__text">
                        Previous {pagination_label}
                    </span>
                </button>
                <div className="trimester-overview__header__divider--desktop"></div>
                </>
            );
        }
    }


    renderTrimesterOverview(){
        var this_component = this;
        var portal_context = this_component['context'];
        var current_trimester = this_component['state']['current_trimester'];

        var configuration = portal_context['configuration'];
        var helpers = portal_context['helpers'];

        var manage_enrolement_id = '889817';
        var PEQ = portal_context['user_personalisation']['attributes']['PEQ'];
        if (!PEQ) {
            manage_enrolement_id = '1397720';
        }
        var manage_enrolement_url = helpers.getDynamicLinkUrlById(manage_enrolement_id);

        var current_trimester = this_component['state']['current_trimester'];

        var trimester_count = this_component['state']['trimester_count'] > 1;

        if(current_trimester){
            var date_format = 'YYYY';
            var trimester_start = makeDate(current_trimester['start'], date_format);

            return (
                <>
                <div className="trimester-overview__wrapper">    
                <div className="trimester-overview__header">

                    {trimester_count && 
                        <this_component.RenderPaginationButton direction="previous" />
                    }
                    
                    <div className="trimester-overview__title">
                        {trimester_start} {current_trimester.name}
                    </div>

                    {trimester_count && 
                        <this_component.RenderPaginationButton direction="next" />
                    }

                    <div className="trimester-overview__enrolment__button__wrapper">
                        <a href={manage_enrolement_url} className="trimester-overview__enrolment__button">
                            Manage enrolment
                        </a>
                    </div>

                </div>

                <div className="trimester-overview__course__header">
                    <div className="trimester-overview__code__title">
                        Course Code
                    </div>
                    <div className="trimester-overview__info__title">
                        Course Name
                    </div>
                    <div className="trimester-overview__coordinator__title">
                        Convenor
                    </div>
                </div>


                    <this_component.RenderCourseDisplay currentTrimester={current_trimester} />
    
                </div>
                </>
            );
        } else {
            // handler for when no data is available

            var error = configuration['system_messages']['nodata']['programCourse'];

            return (
                <>
                <div className="trimester-overview__wrapper">
                    <div className="trimester-overview__error">
                        <p>{error}</p>
                        <a href={manage_enrolement_url} className="btn btn--primary">
                            Manage enrolment
                        </a>
                    </div>
                </div>
                </>
            );
        }

    }

    render() {
        var this_component = this;
        var display = this_component.renderTrimesterOverview();
        
        return (
            <>
                <ContextualMessage id="trimester_overview" />
                {display}
            </>
        );
    }

};

TrimesterOverview.contextType = PortalContext;
